import { useEffect } from "react";

import { useBrand } from "src/hooks/useBrand";

export const DocumentHead = () => {
  const {
    customerPortal: { name: customerPortalName, faviconUrl },
  } = useBrand();

  useEffect(() => {
    document.title = customerPortalName;

    const createLink = (rel: string, href: string, type?: string, sizes?: string) => {
      const link = document.createElement("link");
      link.rel = rel;
      link.href = href;
      if (sizes) {link.setAttribute("sizes", sizes);}
      if (type) {link.type = type;}

      document.head.appendChild(link);
    };

    // Create all favicons
    createLink("icon", `${faviconUrl}/favicon-96x96.png`, "image/png", "96x96");
    createLink("icon", `${faviconUrl}/favicon.svg`, "image/svg+xml");
    createLink("shortcut icon", `${faviconUrl}/favicon.ico`);
    createLink("apple-touch-icon", `${faviconUrl}/apple-touch-icon.png`, undefined, "180x180");
    createLink("manifest", `${faviconUrl}/site.webmanifest`);
  }, [faviconUrl]);

  return null;
};
